import { Helmet } from 'react-helmet-async';
import { Outlet } from 'react-router-dom';
import RestrictedAccess from '@/components/Modal/RestrictedAccess';
import { isGeoBrowseEnabled } from '@/config/geoBrowse';
import { userAppContext } from '@/context/Context';
import NotFoundContent from '@/pages/NotFound';
import type { UserContext } from '@/types';
import { GeoBrowseProvider } from '../context/GeoBrowseContext';

/** Wraps geo-browse routes with provider (used as parent in AppRouter). */
export function GeoBrowseRoot() {
  if (!isGeoBrowseEnabled) {
    return <NotFoundContent />;
  }

  const { user, isAuthenticated } = userAppContext() as UserContext;
  const groups = (user?.['cognito:groups'] as string[] | undefined) ?? [];
  const isAcademicUser = groups.includes('ROLE_ACADEMIC');
  const isRestricted = !isAuthenticated || isAcademicUser;

  return (
    <>
      <Helmet>
        <title>ExpressNET — Gene expression across diseases</title>
        <meta
          name="description"
          content="Gene expression across diseases from GEO RNA-seq differential expression studies."
        />
      </Helmet>
      <RestrictedAccess
        isRestricted={isRestricted}
        restrictedMessage={
          isAcademicUser ? (
            <h6>
              As an academic user, you do not have access to ExpressNET. Please explore other options
              available in{' '}
              <a href="/plans" style={{ color: '#D02591' }}>
                plans
              </a>
              .
            </h6>
          ) : undefined
        }
      >
        {/* Full UI stays mounted so restricted users still see a blurred preview */}
        <GeoBrowseProvider>
          <Outlet />
        </GeoBrowseProvider>
      </RestrictedAccess>
    </>
  );
}
